import React from 'react';
import { connect } from 'react-redux';
import withReactiveStyleBuyButton from './withReactiveStyleBuyButton';
import MyDealerButton from '../Components/MyDealerButton';

const MyDealerButtonContainer = (props) => <MyDealerButton {...props} />;

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withReactiveStyleBuyButton(MyDealerButtonContainer));
